import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';

import { AdminInfoCreateFieldModal } from '../AdminInfoCreateFieldModal/AdminInfoCreateFieldModal';

import useChangeModalVisible from '../../../../../../hooks/useChangeModalVisible';

export const AdminInfoCreateFieldBlock = ({ companyId, orderNum }) => {
  const {
    visible: createFieldModalVisible,
    showModal: showCreateFieldModal,
    hideModal: hideCreateFieldModal,
  } = useChangeModalVisible();

  return (
    <>
      <div style={{ display: 'flex' }}>
        <Button onClick={showCreateFieldModal}>Добавить поле</Button>
      </div>
      <AdminInfoCreateFieldModal
        visible={createFieldModalVisible}
        onSuccess={hideCreateFieldModal}
        onCancel={hideCreateFieldModal}
        companyId={companyId}
        orderNum={orderNum}
      />
    </>
  );
};

AdminInfoCreateFieldBlock.propTypes = {
  companyId: PropTypes.number.isRequired,
  orderNum: PropTypes.number.isRequired,
};
